import API from '../config/api';

export async function downloadAnalyticsPdf({
  apiPath,
  analytics,
  account,
  brand,
  filename,
}) {
  if (!analytics) throw new Error('No analytics data to export');
  const response = await API.post(
    apiPath,
    { analytics, account, brand },
    { responseType: 'blob' },
  );
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'Experiment_Analytics_Report.pdf';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export function analyticsPdfFilename(protocolName) {
  const safe = String(protocolName || 'Experiment')
    .replace(/[^\w\-]+/g, '_')
    .replace(/_+/g, '_')
    .slice(0, 80);
  return `${safe || 'Experiment'}_Analytics_Report.pdf`;
}
